module.exports = __webpack_public_path__ + "static/media/group-49.b817a647.svg";